import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppDispatch, RootState } from '../index';
import { storageResetAction } from '../storeReset';
import { getMenuHidden, setMenuHidden } from '../../utils/storage';

export interface UiState {
  menuHidden: boolean;
}

const initialState: UiState = {
  menuHidden: getMenuHidden(),
};

export const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setMenuHidden(state, action: PayloadAction<boolean>) {
      state.menuHidden = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(storageResetAction, (state) => {
      state.menuHidden = false;
    });
  },
});

export const uiActions = uiSlice.actions;

export const selectMenuHidden = (state: RootState): boolean => state.ui.menuHidden;

export const updateMenuHidden = (hidden: boolean) => (dispatch: AppDispatch) => {
  setMenuHidden(hidden);
  dispatch(uiActions.setMenuHidden(hidden));
};
